import { DatePipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';
import { TranslateConfigService } from '@app/core/translate-config.service';
import { DateTime } from 'luxon';

@Pipe({
  name: 'dateTranslate',
})
export class DateTranslatePipe implements PipeTransform {
  constructor(private translate: TranslateConfigService, private datePipe: DatePipe) {}

  transform(value: Date | string | number, format: string = 'EEEE d MMMM y'): string {
    if (!value) return '';

    const dateTime = DateTime.fromJSDate(new Date(value));

    const weekday = this.translate.instant(`createScreen.days.${dateTime.weekdayLong.toLowerCase()}`);
    const month = this.translate.instant(`global.months.${dateTime.monthLong.toLowerCase()}`);

    const formatted = this.datePipe.transform(value, format);

    return formatted?.replace(dateTime.weekdayLong, weekday)?.replace(dateTime.monthLong, month) ?? '';
  }
}
